module.exports = __webpack_public_path__ + "img/宣传_06.fcd90c98.jpg";